module.exports = __webpack_public_path__ + "static/media/outreach.1360c2cf.svg";